import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const aiGenerationApi = {
  /**
   * Generate AI newsletter drafts for all subscribers of this moderator.
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  generateAll: (config) => mod.post('/ai/generate-digests', null, config),

  /**
   * Generate AI newsletter draft for a single subscriber.
   * @param {number} userId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  generateForSubscriber: (userId, config) =>
    mod.post(`/ai/generate-digests/${userId}`, null, config),

  /**
   * Poll current AI generation progress.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').GenerationStatus>>}
   */
  getStatus: (config) => mod.get('/ai/generation-status', config),

  /**
   * Read per-subscriber draft readiness for today.
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').SubscriberReadinessResponse>>}
   */
  subscriberReadiness: (config) => mod.get('/ai/subscriber-readiness', config),

  /**
   * Generate drafts only for subscribers that still need one today.
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  autoGenerateCheck: (config) => mod.post('/ai/auto-generate-check', null, config),
};
